import { render, staticRenderFns } from "./SetWebCallPermissionBulk.vue?vue&type=template&id=490286f4&"
import script from "./SetWebCallPermissionBulk.vue?vue&type=script&lang=js&"
export * from "./SetWebCallPermissionBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports